import React from 'react';
import { BsDownload } from 'react-icons/bs';

const OverdueLoans = () => {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Loan ID</th>
            <th>Loan Amount</th>
            <th>Repayment Amount</th>
            <th>Loan Start Date</th>
            <th>Loan Amount Paid</th>
            <th>Minimum Overdue Date</th>
            <th>Number of Overdue Repayments</th>
            <th>Total Overdue Amount</th>
            <th>Last Repayments Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>$700,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>14-11-2021</td>
            <td>3</td>
            <td>600,000</td>
            <td>14-11-2021</td>
          </tr>
        </tbody>
      </table>
      <div className="download-btn">
        <button><span>Download</span><BsDownload /></button>
      </div>
    </div>
  )
}

export default OverdueLoans;